import { getPlatformUrl } from "./platform-content-array";

/**
 * A stable `@id` anchored on the platform root, for entities not tied to one page: a deal tile
 * appears on many pages but must keep the same identity. The url-addition is included so BENL and
 * BEFR, which share the blackfridayexpert.be domain, stay distinct sites.
 */
export const getPlatformAnchorId = (platformId: number, anchor: string): string =>
  `${getPlatformUrl(platformId)}/#${anchor}`;

/** No WebSite node describing this `@id` is emitted yet, so `isPartOf` points at an undefined entity. */
export const getWebSiteId = (platformId: number): string => getPlatformAnchorId(platformId, "website");
